import React, {useEffect, useMemo, useState} from "react";
import {CodeSpecNum} from "../../../../constant/CodeSpecNum";
import Search from "../../../../components/search/Search";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {removeInspectionHeaders} from "../../../../api/maintenance/InspectionService";
import {INSPECTION_HEADER_LIST_HEADER} from "../../../../components/table/header/Headers";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {searchWithChildren} from "../../../../components/commonmethod/simmsDrawerMethod";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";

function InspectionHeaderListType({checked, data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: INSPECTION_HEADER_LIST_HEADER, exclude: []});
    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, INSPECTION_HEADER_LIST_HEADER, setHeader, [], () => {}, () => {}, 'inspection_header');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "정기점검 상세"),
            url: `/maintenance/inspection_header/${id}`,
        });
    };

    const deleteInspectionHeader = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 정기점검을 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        await removeInspectionHeaders({ids}).then((response) => {
            if (response.status === 200) {
                handleActiveToast({message: "데이터가 삭제되었습니다"});
            } else if (response.status === 403) {
                handleActiveError({message: "권한이 없습니다."});
            } else {
                handleActiveError({message: "알 수 없는 에러 발생."});
            }
        });
        checked?.setChecked?.([]);
        refresh();
    };

    const inspectionHeaderJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'inspection_header'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} size detail date={searchDate} searchBar={{placeHolder: '점검제목'}}>
                <SearchSection>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'group', extractObject(saveConditions), value)}
                                 data={saveConditions.group}
                                 parentKey={CodeSpecNum.AssetGroupCode} recursive
                                 entity={"code"} title={"자산그룹"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'task', extractObject(saveConditions), value)}
                                 data={saveConditions.task}
                                 parentKey={CodeSpecNum.TaskGroupCode} recursive
                                 entity={"code"} title={"업무그룹"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'inspect', extractObject(saveConditions), value)}
                                 data={saveConditions.inspect}
                                 parentKey={CodeSpecNum.InspectionRequestCode} recursive
                                 entity={"code"} title={"점검코드"} />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={inspectionHeaderJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {inspection_header: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'inspection_header')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="InspectionHeader" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteInspectionHeader}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveToast({message: "삭제할 정기점검을 선택해주세요."});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/maintenance/inspection_header/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export {InspectionHeaderListType};
